module Meevo.Components.Controls.SmartMover {
    import Membership = Model.Membership;


    export class MembershipsCollection extends SmartMoverApiCollection<Membership> implements IApiCollection<Membership> {

        get url() {
            return 'Membership';
        }
    }

}
